"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _checkTypes = _interopRequireDefault(require("check-types"));

var _darkorlight = _interopRequireDefault(require("darkorlight"));

var _semanticUiReact = require("semantic-ui-react");

var _Colors = require("../00_environment/Colors");

var _Fonts = require("../00_environment/Fonts");

var _Constants = require("../00_environment/Constants");

var _Top = _interopRequireDefault(require("./Top"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var color = _darkorlight["default"].dark(_Colors.topBarBgColor) ? _Colors.onDarkTextColor : _Colors.textColor;
var subColor = _darkorlight["default"].dark(_Colors.topBarSubBgColor) ? _Colors.onDarkTextColor : _Colors.textColor;

var LegacyTopBar = function LegacyTopBar(_ref) {
  var title = _ref.title,
      _ref$leftIcon = _ref.leftIcon,
      leftIcon = _ref$leftIcon === void 0 ? null : _ref$leftIcon,
      _ref$onLeftIconClick = _ref.onLeftIconClick,
      onLeftIconClick = _ref$onLeftIconClick === void 0 ? function () {} : _ref$onLeftIconClick,
      _ref$rightIcon = _ref.rightIcon,
      rightIcon = _ref$rightIcon === void 0 ? null : _ref$rightIcon,
      _ref$rightIconLink = _ref.rightIconLink,
      rightIconLink = _ref$rightIconLink === void 0 ? null : _ref$rightIconLink,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$rightChildren = _ref.rightChildren,
      rightChildren = _ref$rightChildren === void 0 ? null : _ref$rightChildren,
      _ref$tabs = _ref.tabs,
      tabs = _ref$tabs === void 0 ? null : _ref$tabs,
      _ref$selectedTab = _ref.selectedTab,
      selectedTab = _ref$selectedTab === void 0 ? null : _ref$selectedTab;

  var content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _Fonts.withTopBarFont)({
      backgroundColor: _Colors.topBarBgColor,
      color: color,
      margin: 0,
      flex: '1',
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'left',
      alignItems: 'center',
      padding: 0,
      position: 'relative',
      border: 'none'
    })
  }, leftIcon && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      cursor: 'pointer',
      margin: 15,
      marginRight: 0
    },
    onClick: onLeftIconClick
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    name: leftIcon
  })), title && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: 15,
      marginLeft: 10
    }
  }, title), _checkTypes["default"].nonEmptyArray(tabs) && /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _Fonts.withTopBarFont)({
      margin: 0,
      padding: 0,
      height: '100%',
      position: 'relative',
      display: 'flex',
      flexDirection: 'row'
    })
  }, tabs.map(function (t) {
    if (!_checkTypes["default"].nonEmptyString(t.name) || !_checkTypes["default"].nonEmptyString(t.link) || !_checkTypes["default"].nonEmptyString(t.icon)) {
      return null;
    }

    var selected = t.name === selectedTab;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "tab:".concat(t.name),
      style: (0, _Fonts.withTopBarFont)({
        height: '100%',
        borderBottom: selected ? "solid 2px ".concat(color) : 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      })
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: t.link,
      style: {
        color: selected ? color : _Colors.topBarIdleTabColor,
        textDecoration: 'none'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row'
      }
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
      name: t.icon
    }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Responsive, {
      as: "div",
      minWidth: 768,
      style: {
        marginLeft: 10
      }
    }, t.displayName || t.name))));
  })), rightChildren && /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread({
      marginLeft: 'auto',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center'
    }, rightChildren ? {} : {
      marginLeft: 'auto'
    })
  }, rightChildren), rightIcon && rightIconLink && /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread({
      cursor: 'pointer',
      padding: 5
    }, rightChildren ? {} : {
      marginLeft: 'auto'
    })
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: rightIconLink,
    style: (0, _Fonts.withTopBarFont)({
      color: color,
      textDecoration: 'none'
    })
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    name: rightIcon
  })))), children && /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _Fonts.withDefaultFont)({
      backgroundColor: _Colors.topBarSubBgColor,
      flex: '1',
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'left',
      alignItems: 'center',
      padding: 15,
      color: subColor,
      margin: 0
    })
  }, children));

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Top["default"], null, content), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      visibility: 'hidden'
    }
  }, content));
};

var TopBar = _Constants.displayTopBar ? LegacyTopBar : function (_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
};
var _default = TopBar;
exports["default"] = _default;